// import { useTranslation } from 'react-i18next';
// import flagofbelgium from '../../assets/flagofbelgium.png';
// import flagofnetherlands from '../../assets/flagofnetherlands.png';

// interface CountrySelectorProps {
//   selectedCountry: string;
//   onCountrySelect: (country: string) => void;
// }

// export const CountrySelector = ({ selectedCountry, onCountrySelect }: CountrySelectorProps) => {
//   const { t } = useTranslation('AddCompany');

//   return (
//     <div className='flex bg-white text-primary-600 rounded-t-2xl'>
//       <div
//         className={`flex gap-3 px-4 py-5 flex-1 cursor-pointer rounded-tl-2xl
//           ${selectedCountry === 'Belgium' ? 'bg-white border' : 'bg-gray-50'}
//         `}
//         onClick={() => onCountrySelect('Belgium')}
//       >
//         <div>
//           <img src={flagofbelgium} alt='Flag of Belgium' className='rounded-full size-10' />
//         </div>
//         <div>
//           <p className='font-semibold'>Belgium</p>
//           <p className='text-primary-500'>{t('registerWithCBE')}</p>
//         </div>
//       </div>

//       <div
//         className={`flex gap-3 px-4 py-5 flex-1 cursor-pointer rounded-tr-2xl
//           ${selectedCountry === 'Netherlands' ? 'bg-white border' : 'bg-gray-50'}
//         `}
//         onClick={() => onCountrySelect('Netherlands')}
//       >
//         <div>
//           <img src={flagofnetherlands} alt='Flag of Netherlands' className='rounded-full size-10' />
//         </div>
//         <div>
//           <p className='font-semibold'>Netherlands</p>
//           <p className='text-primary-500'>{t('registerWithCOC')}</p>
//         </div>
//       </div>
//     </div>
//   );
// };

import { useTranslation } from 'react-i18next';
import flagofbelgium from '../../assets/flagofbelgium.png';
import { useEffect } from 'react';

interface CountrySelectorProps {
  onCountrySelect: (country: string) => void;
}

export const CountrySelector = ({ onCountrySelect }: CountrySelectorProps) => {
  const { t } = useTranslation('AddCompany');
  useEffect(() => {
    onCountrySelect('Belgium');
  }, []);

  return (
    <div className='flex bg-white text-primary-600 rounded-2xl'>
      <div
        className='flex gap-3 px-4 py-5 flex-1 cursor-pointer rounded-2xl bg-white border'
        onClick={() => onCountrySelect('Belgium')}
      >
        <div>
          <img src={flagofbelgium} alt='Flag of Belgium' className='rounded-full size-10' />
        </div>
        <div>
          <p className='font-semibold'>Belgium</p>
          <p className='text-primary-500'>{t('registerWithCBE')}</p>
        </div>
      </div>
    </div>
  );
};
